import styled from 'styled-components';

export const ThumbnailWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  pointer-events: none;
  user-select: none;
`;

export const ThumbnailScale = styled.div`
  width: 220%;
  transform: scale(0.45);
  transform-origin: top left;
`;

export const FullWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  overflow-y: auto;
  overflow-x: hidden;
  pointer-events: none;
  user-select: none;
  padding: ${(props) => props.theme.spacing.xxl};
`;

export const PreviewCardContainer = styled.div`
  width: ${(props) => (props.$widthPercent ? `${props.$widthPercent}%` : '100%')};
  max-width: ${(props) => (props.$widthPercent ? 'none' : '560px')};
  height: ${(props) => (props.$heightPx ? `${props.$heightPx}px` : 'auto')};
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.06);
  border-radius: ${(props) => props.theme.borderRadius.base};
  overflow: hidden;
  transition: width 0.25s ease, height 0.25s ease;
`;
